<template>
  <v-card>
    <v-card-title>
      Select days &amp; times
    </v-card-title>
    <v-card-text>
      <v-checkbox label="Select All" v-model="selectAllDays"></v-checkbox>
      <v-item-group multiple v-model="selectedDays">
        <v-row justify="center">
          <v-col v-for="day in daysOfWeek" :key="day" cols="auto" :class="{'px-2': isMobile}">
            <v-item v-slot="{ active, toggle }" :value="day">
              <v-btn
                fab
                :outlined="!active"
                elevation="0"
                @click="toggle"
                :x-small="isMobile"
                :color="dayOfWeekColor(active)">
                {{day.charAt(0)}}
              </v-btn>
            </v-item>
          </v-col>
        </v-row>
      </v-item-group>
      <v-container class="mt-5">
        <v-row align="center" v-for="(range, i) in ranges" :key="range.id">
          <v-col>
            <v-row>
              <v-col>
                <EsTimePicker
                  placeholder="Start Time"
                  :initialTime="range.startTime"
                  :dark="dark"
                  v-on:setTime="saveStartTime(i, $event)" />
              </v-col>
              <v-col>
                <EsTimePicker
                  placeholder="End Time"
                  :initialTime="range.endTime"
                  :dark="dark"
                  v-on:setTime="saveEndTime(i, $event)" />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="auto">
            <EsButtonIcon icon="mdi-close"
              @click="removeRange(i)" />
          </v-col>
        </v-row>
        <EsButtonAction
          class="mt-5"
          block
          label="Add Hours"
          icon="mdi-plus-circle-outline"
          @click="addRange()" />
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-row>
        <v-col>
          <EsButtonCancel block
            @click="resetAndCloseDialog()" />
        </v-col>
        <v-col>
          <EsButtonSave block
            :loading="isSaving"
            @click="saveHours()" />
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
import {
  EsButtonIcon,
  EsButtonAction,
  EsButtonCancel,
  EsButtonSave,
} from "@86-repairs/design-system";
import EsTimePicker from './EsTimePicker.vue';

export default {
  name: 'EsServiceHoursDialog',
  props: {
    daysOfWeek: {
      type: Array,
      required: true,
    },
    selectedDay: {
      type: String,
      required: true,
    }, 
    existingRanges: {
      type: Array,
      default: () => [],
    },
    dark: {
      type: Boolean,
      default: false,
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
    isSaving: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    EsButtonIcon,
    EsButtonAction,
    EsButtonCancel,
    EsButtonSave,
    EsTimePicker,
  },
  data: () => ({
    selectedDays: [],
    ranges: [],
    selectAllDays: false,
  }),
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  mounted() {
    this.selectedDays.push(this.selectedDay);
    if (this.existingRanges) {
      this.ranges = this.existingRanges;
    }
  },
  watch: {
    isOpen(value) {
      if (!value) {
        this.resetDialog();
      } else {
        this.selectedDays.push(this.selectedDay);
      }
    },
    existingRanges(value) {
      if (value) {
        this.ranges = value;
      }
    },
    selectAllDays(value) {
      if (value) {
        this.selectedDays = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
      } else {
        this.selectedDays = [this.selectedDay];
      }
    }
  },
  methods: {
    saveStartTime(index, time) {
      const rangeToEdit = this.ranges[index];
      rangeToEdit.startTime = time;
    },
    saveEndTime(index, time) {
      const rangeToEdit = this.ranges[index];
      rangeToEdit.endTime = time;
    },
    addRange() {
      this.ranges.push({ startTime: '09:00 AM', endTime: '05:00 PM' });
    },
    removeRange(index) {
      this.ranges.splice(index, 1);
    },
    resetDialog() {
      this.selectedDays = [];
      this.ranges = [];
    },
    resetAndCloseDialog() {
      this.resetDialog();
      this.$emit('closeDialog');
    },
    saveHours() {
      this.$emit('saveHours', { days: this.selectedDays, ranges: this.ranges});
    },
    dayOfWeekColor(active) {
      return active
        ? 'primary'
        : this.dark
          ? 'white'
          : 'accent';
    }
  },
};
</script>
